import { render } from "./B2bPageAddPartiesService.vue?vue&type=template&id=2d987a7a&scoped=true&lang=pug"
import script from "./B2bPageAddPartiesService.vue?vue&type=script&lang=js"
export * from "./B2bPageAddPartiesService.vue?vue&type=script&lang=js"

import "./B2bPageAddPartiesService.vue?vue&type=style&index=0&id=2d987a7a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d987a7a"]])

export default __exports__